/**
 * Dev-only logging for MONATSKOMMENTAR / monthlyCommentary data flow.
 * Filter console by: [PDFV2 monthly]
 */
const isDev =
  typeof process !== 'undefined' && process.env.NODE_ENV === 'development';

/** Delay before pushing monthly commentary to parent (preview) — reduces heavy re-renders while typing */
export const MONTHLY_COMMENTARY_DEBOUNCE_MS = 400;

/** Same delay for other PdfConfig text fields → parent (preview) sync */
export const PDF_CONFIG_PARENT_DEBOUNCE_MS = MONTHLY_COMMENTARY_DEBOUNCE_MS;

export function logMonthlyCommentary(scope: string, payload: Record<string, unknown>): void {
  if (!isDev) return;
  console.log(`[PDFV2 monthly] ${scope}`, payload);
}

/** Scroll a node into view inside the nearest scrollable ancestor (preview column has its own overflow). */
export function scrollElementIntoScrollableColumn(element: HTMLElement, offsetTop = 12): boolean {
  let parent: HTMLElement | null = element.parentElement;
  while (parent && parent !== document.body) {
    const style = window.getComputedStyle(parent);
    const canScrollY =
      /(auto|scroll)/.test(style.overflowY) && parent.scrollHeight > parent.clientHeight + 1;
    if (canScrollY) {
      const elRect = element.getBoundingClientRect();
      const parRect = parent.getBoundingClientRect();
      const delta = elRect.top - parRect.top - offsetTop;
      parent.scrollTo({ top: parent.scrollTop + delta, behavior: 'smooth' });
      return true;
    }
    parent = parent.parentElement;
  }
  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return false;
}
